import { isMeasurementReportType } from '../resources/measurementsReports.types';
import { commons, measurements } from './MetricIds';
export var Temperature;
(function (Temperature) {
    Temperature[Temperature["celsiusDegrees"] = 0] = "celsiusDegrees";
    Temperature[Temperature["fahrenheitDegrees"] = 1] = "fahrenheitDegrees";
    Temperature[Temperature["kelvins"] = 2] = "kelvins";
})(Temperature || (Temperature = {}));
export var ElectricalConductivity;
(function (ElectricalConductivity) {
    ElectricalConductivity[ElectricalConductivity["milliSiemensPerMeter"] = 0] = "milliSiemensPerMeter";
    ElectricalConductivity[ElectricalConductivity["deciSiemensPerMeter"] = 1] = "deciSiemensPerMeter";
})(ElectricalConductivity || (ElectricalConductivity = {}));
// TODO: rename to something like "Part" maybe ?
export var Humidity;
(function (Humidity) {
    Humidity[Humidity["percents"] = 0] = "percents";
})(Humidity || (Humidity = {}));
export var Angle;
(function (Angle) {
    Angle[Angle["degrees"] = 0] = "degrees";
})(Angle || (Angle = {}));
export var Speed;
(function (Speed) {
    Speed[Speed["kilometersPerHour"] = 0] = "kilometersPerHour";
    Speed[Speed["metersPerSecond"] = 1] = "metersPerSecond";
    Speed[Speed["milesPerHour"] = 2] = "milesPerHour";
    Speed[Speed["beaufort"] = 3] = "beaufort";
})(Speed || (Speed = {}));
export var Length;
(function (Length) {
    Length[Length["millimeters"] = 0] = "millimeters";
    Length[Length["inches"] = 1] = "inches";
})(Length || (Length = {}));
export var Pressure;
(function (Pressure) {
    Pressure[Pressure["kiloPascals"] = 0] = "kiloPascals";
    Pressure[Pressure["millibars"] = 1] = "millibars";
})(Pressure || (Pressure = {}));
/** @description Frontend only */
export var HeatAccumulation;
(function (HeatAccumulation) {
    HeatAccumulation[HeatAccumulation["celsiusDegreesDay"] = 0] = "celsiusDegreesDay";
    HeatAccumulation[HeatAccumulation["fahrenheitDegreesDay"] = 1] = "fahrenheitDegreesDay";
})(HeatAccumulation || (HeatAccumulation = {}));
export var Time;
(function (Time) {
    Time[Time["seconds"] = 0] = "seconds";
    Time[Time["hours"] = 1] = "hours";
})(Time || (Time = {}));
export var Acceleration;
(function (Acceleration) {
    Acceleration[Acceleration["metersPerSecondSquare"] = 0] = "metersPerSecondSquare";
})(Acceleration || (Acceleration = {}));
export var Voltage;
(function (Voltage) {
    Voltage[Voltage["volts"] = 0] = "volts";
    Voltage[Voltage["millivolts"] = 1] = "millivolts";
})(Voltage || (Voltage = {}));
export var Percent;
(function (Percent) {
    Percent[Percent["percent"] = 0] = "percent";
})(Percent || (Percent = {}));
export var SurfacePowerDensity;
(function (SurfacePowerDensity) {
    SurfacePowerDensity[SurfacePowerDensity["wattsPerSquareMeter"] = 0] = "wattsPerSquareMeter";
})(SurfacePowerDensity || (SurfacePowerDensity = {}));
export var PhotosyntheticActiveRadiation;
(function (PhotosyntheticActiveRadiation) {
    PhotosyntheticActiveRadiation[PhotosyntheticActiveRadiation["photosyntheticPhotonFluxDensity"] = 0] = "photosyntheticPhotonFluxDensity";
})(PhotosyntheticActiveRadiation || (PhotosyntheticActiveRadiation = {}));
/** @description Frontend only */
export var RainfallIntensity;
(function (RainfallIntensity) {
    RainfallIntensity[RainfallIntensity["millimetersPerHour"] = 0] = "millimetersPerHour";
    RainfallIntensity[RainfallIntensity["inchesPerHour"] = 1] = "inchesPerHour";
})(RainfallIntensity || (RainfallIntensity = {}));
export var Distance;
(function (Distance) {
    Distance[Distance["kilometers"] = 0] = "kilometers";
    Distance[Distance["miles"] = 1] = "miles";
})(Distance || (Distance = {}));
/**
 * Physical property of a material or system that can be quantified by measurement.
 * A physical quantity can be expressed as a value, multiplication of a value and a unit.
 */
const physicalQuantities = [
    'temperature',
    'length',
    'windSpeed',
    'percent',
    /** should be renamed to angle */
    'degrees',
    /** Pressure or Stress */
    'pressure',
    'heatAccumulation',
    'leafWetness',
    /** should be under time */
    'leafWetnessDuration',
    'voltage',
    'time',
    /** should be renamed to lengthPerHour */
    'rainfallIntensity',
    'surfacePowerDensity',
    'photosyntheticActiveRadiation',
    'electricalConductivity',
    'distance'
];
const dimensionlessMetrics = ['CLDC'];
export const isDimensionlessMetric = (metric) => dimensionlessMetrics.includes(metric);
export const isMetricWithUnit = (metric) => (measurements.includes(metric) ||
    metric === 'etp' ||
    metric === 'distance' ||
    commons.includes(metric) ||
    isMeasurementReportType(metric)) &&
    !isDimensionlessMetric(metric);
export const PhysicalQuantityPerMetric = {
    ASES: 'time',
    CAPA: 'percent',
    COLD_T_HOUR: 'time',
    DD: 'degrees',
    DRN: 'length',
    dryMatter: 'percent',
    DXY: 'degrees',
    ECP: 'electricalConductivity',
    SWC: 'percent',
    etp: 'length',
    FF: 'windSpeed',
    FXY: 'windSpeed',
    HDEF: 'length',
    heatAccumulation: 'heatAccumulation',
    HPOT: 'pressure',
    IRR: 'length',
    irrigation: 'length',
    dripIrrigation: 'length',
    LW_D: 'leafWetnessDuration',
    LW_V: 'leafWetness',
    PPFD: 'photosyntheticActiveRadiation',
    PPFD_MIN: 'photosyntheticActiveRadiation',
    PPFD_MAX: 'photosyntheticActiveRadiation',
    rainfallIntensity: 'rainfallIntensity',
    rainfalls: 'length',
    RR: 'length',
    RRAccumulation: 'length',
    SSI_HOURS: 'time',
    SSI_HOURSAccumulation: 'time',
    SSI: 'surfacePowerDensity',
    SSI_MIN: 'surfacePowerDensity',
    SSI_MAX: 'surfacePowerDensity',
    T_CAL: 'temperature',
    T_CAPA: 'temperature',
    T_DEW: 'temperature',
    T_DRY: 'temperature',
    T_SOIL: 'temperature',
    T_WET: 'temperature',
    T: 'temperature',
    TN: 'temperature',
    TX: 'temperature',
    U_CAPA: 'percent',
    U: 'percent',
    UN: 'percent',
    UX: 'percent',
    VOLT: 'voltage',
    VPD: 'pressure',
    distance: 'distance'
};
export const DisplayUnitPerDimensionlessMetrics = {
    CLDC: 'percent'
};
